var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      attrs: {
        id: "main-wrapper",
        "data-layout": "vertical",
        "data-navbarbg": "skin5",
        "data-sidebartype": _vm.sidebarType,
        "data-sidebar-position": "absolute",
        "data-header-position": "absolute",
        "data-boxed-layout": "full",
      },
    },
    [
      _c("admin-header"),
      _vm._v(" "),
      _c("admin-sidebar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-wrapper" },
        [
          !_vm.hasPermissionToViewPage
            ? _c(
                "div",
                {
                  staticClass:
                    "no-access-text text-danger font-24 font-weight-bold",
                },
                [
                  _vm._v("\n      Sorry! "),
                  _c("br"),
                  _vm._v(
                    "\n      You don't have permission to view this page.\n    "
                  ),
                ]
              )
            : _c("router-view"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }